import {
  getGTMElementName,
  getGTMEventSection,
  getGTMElementType,
  getTargetElement,
} from '@tracking/components/utils';

function getElementName(target, element) {
  const gtmTextElement = target?.closest('[data-gtm-text]');

  let text = target?.textContent ? target.textContent.trim() : element;
  if (target?.getAttribute('value')) {
    text = target.getAttribute('value');
  } else if (gtmTextElement?.getAttribute('data-gtm-text')) {
    text = gtmTextElement.getAttribute('data-gtm-text');
  }

  return text;
}

function getElementUrl(target, targetElement) {
  const targetElementUrl = targetElement?.href ?? '';
  const url = target?.href ?? targetElementUrl;

  return url;
}

export function mixPanelClickHandler(event) {
  if (event?.target) {
    const element = getGTMElementName(event.target);
    if (!element) {
      return;
    }
    const targetElement = getTargetElement(event.target);
    const elementSection = getGTMEventSection(event.target);
    const elementCategory = getGTMElementType(event.target);
    const elementName = getElementName(event.target, element);
    const elementUrl = getElementUrl(event.target, targetElement);

    window.GTMtracker.pushEvent({
      event: 'gtm_custom_click',
      data: {
        click_text: elementName,
        click_type: elementCategory,
        click_section: elementSection,
        click_url: elementUrl,
      },
    });
  }
}
